<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas :notificacaoSocket="alertaSocket" :texto="alerta.texto" :tipo="alerta.tipo"></Alertas>

    <AlertaSnackbar :habilitar="alertaSnackbar.mostrar" :texto="alertaSnackbar.texto" :cor="alertaSnackbar.cor" v-on:snack-close="alertaSnackbar.mostrar = false" />

    <v-form v-model="tudoValido">
      <v-row align="center" class="px-12">
        <v-col cols="12">
          <v-toolbar flat>
            <v-toolbar-title>| Relatório Dispensas Teste Rápido</v-toolbar-title>
          </v-toolbar>
        </v-col>

        <v-col cols="12">
          <v-autocomplete v-model="filtrosRelatorio.numeroEndereco" :items="listaDeUnidades" :loading="!listaDeUnidades" :readonly="!listaDeUnidades" :no-data-text="''" clearable label="Unidades" autocomplete="off" prepend-icon="mdi-domain"></v-autocomplete>
        </v-col>

        <v-col cols="6">
          <v-autocomplete
            v-model="filtrosRelatorio.indicadorGravidez"
            :items="filtroGestantes"
            :loading="!filtroGestantes"
            :readonly="!filtroGestantes"
            :no-data-text="''"
            color="blue-grey lighten-2"
            label="Filtrar por Gestantes:"
            autocomplete="off"
            clearable
            prepend-icon="mdi-ab-testing"
          ></v-autocomplete>
        </v-col>

        <v-col cols="6">
          <v-autocomplete
            v-model="filtrosRelatorio.indicadorResultado"
            :items="filtroResultados"
            :loading="!filtroResultados"
            :readonly="!filtroResultados"
            :no-data-text="''"
            color="blue-grey lighten-2"
            label="Filtrar por Resultados:"
            autocomplete="off"
            clearable
            prepend-icon="mdi-ab-testing"
          ></v-autocomplete>
        </v-col>

        <v-col cols="6">
          <v-autocomplete
            v-model="filtrosRelatorio.indicadorPerdido"
            :items="filtroPerdidos"
            :loading="!filtroPerdidos"
            :readonly="!filtroPerdidos"
            :no-data-text="''"
            color="blue-grey lighten-2"
            label="Filtrar por Perdidos:"
            autocomplete="off"
            clearable
            prepend-icon="mdi-ab-testing"
          ></v-autocomplete>
        </v-col>

        <v-col cols="6">
          <v-autocomplete
            v-model="filtrosRelatorio.indicadorDefeito"
            :items="filtroDefeitos"
            :loading="!filtroDefeitos"
            :readonly="!filtroDefeitos"
            :no-data-text="''"
            color="blue-grey lighten-2"
            label="Filtrar por Defeito:"
            autocomplete="off"
            clearable
            prepend-icon="mdi-ab-testing"
          ></v-autocomplete>
        </v-col>
      </v-row>

      <v-row align="center" class="px-12 pb-12">
        <v-col cols="12" lg="6">
          <v-menu v-model="menuDe" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
            <template v-slot:activator="{ on }">
              <v-text-field
                v-on="on"
                v-model="filtrosRelatorio.dataInicioFormatada"
                label="De:"
                hint="DD/MM/AAAA"
                persistent-hint
                prepend-icon="mdi-calendar-today"
                autocomplete="off"
                v-mask="['##/##/####']"
                color="blue-grey lighten-2"
                @blur="filtrosRelatorio.dataInicio = analizarData(filtrosRelatorio.dataInicioFormatada)"
              ></v-text-field>
            </template>
            <v-date-picker v-model="filtrosRelatorio.dataInicio" no-title @input="menuDe = false" @change="filtrosRelatorio.dataInicioFormatada = formatarData(filtrosRelatorio.dataInicio)"></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" lg="6">
          <v-menu v-model="menuAte" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
            <template v-slot:activator="{ on }">
              <v-text-field
                v-on="on"
                v-model="filtrosRelatorio.dataFimFormatada"
                label="Até"
                hint="DD/MM/AAAA"
                persistent-hint
                prepend-icon="mdi-calendar"
                autocomplete="off"
                v-mask="['##/##/####']"
                color="blue-grey lighten-2"
                @blur="filtrosRelatorio.dataFim = analizarData(filtrosRelatorio.dataFimFormatada)"
              ></v-text-field>
            </template>
            <v-date-picker v-model="filtrosRelatorio.dataFim" no-title @input="menuAte = false" @change="filtrosRelatorio.dataFimFormatada = formatarData(filtrosRelatorio.dataFim)"></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" align="center">
          <v-btn :disabled="botaoGerarRelatorio" width="300" color="grey darken-4" class="white--text" @click="gerarRelatorio"> GERAR RELATÓRIO </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <Loading :open="loading" />

    <FormRelatorio :isTheModalOpen="formRelatorio.isOpen" :modalTitleToolbar="formRelatorio.modalTitleToolbar" v-on:fecharModal="fecharFormRelatorio" v-on:generate-excel="gerarExcel(formRelatorio.dataRelatorio)">
      <!-- #region GRAFICOS E MEDIAS -->
      <v-row>
        <v-col cols="12">
          <v-card class="mx-5">
            <v-col v-for="dados in dadosRelatorioOrganizados" :key="dados.nomeItem">
              <v-card-title>{{ dados.nomeItem }}</v-card-title>
              <v-row class="mb-6" no-gutters>
                <v-col cols="2" class="pa-md-1">
                  <v-card color="blue lighten-3" dark>
                    <v-card-title>
                      <div class="headline grey--text text--darken-2">
                        {{ dados.gravidez1.resultado1 }}
                      </div>
                    </v-card-title>
                    <v-card-actions class="px-4 py-2 grey--text text--darken-2">Gravidas reagente</v-card-actions>
                  </v-card>
                </v-col>

                <v-col cols="2" class="pa-md-1">
                  <v-card color="green lighten-3" dark>
                    <v-card-title>
                      <div class="headline grey--text text--darken-2">
                        {{ dados.gravidez1.resultado0 }}
                      </div>
                    </v-card-title>
                    <v-card-actions class="px-4 py-2 grey--text text--darken-2">Gravidas não reagente</v-card-actions>
                  </v-card>
                </v-col>

                <v-col cols="2" class="pa-md-1">
                  <v-card color="red lighten-3" dark>
                    <v-card-title>
                      <div class="headline grey--text text--darken-2">
                        {{ dados.gravidez0.resultado1 }}
                      </div>
                    </v-card-title>
                    <v-card-actions class="px-4 py-2 grey--text text--darken-2">Não gravidadas reagentes</v-card-actions>
                  </v-card>
                </v-col>

                <v-col cols="2" class="pa-md-1">
                  <v-card color="yellow lighten-3" dark>
                    <v-card-title>
                      <div class="headline grey--text text--darken-2">
                        {{ dados.gravidez0.resultado0 }}
                      </div>
                    </v-card-title>
                    <v-card-actions class="px-4 py-2 grey--text text--darken-2">Não gravidadas não reagentes</v-card-actions>
                  </v-card>
                </v-col>
                <v-col cols="2" class="pa-md-1">
                  <v-card color="grey lighten-3" dark>
                    <v-card-title>
                      <div class="headline grey--text text--darken-2">
                        {{ dados.perdido1 }}
                      </div>
                    </v-card-title>
                    <v-card-actions class="px-4 py-2 grey--text text--darken-2">Perdidos</v-card-actions>
                  </v-card>
                </v-col>
                <v-col cols="2" class="pa-md-1">
                  <v-card color=" lighten-3" dark>
                    <v-card-title>
                      <div class="headline grey--text text--darken-2">
                        {{ dados.defeito1 }}
                      </div>
                    </v-card-title>
                    <v-card-actions class="px-4 py-2 grey--text text--darken-2">Defeito</v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>

            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="4" align="center">
                  <div class="titulo">Totais por Defeito</div>

                  <Doughnut :chartData="formRelatorio.dataRelatorio.graficoDefeituosos" :options="doughnutOptions"></Doughnut>
                </v-col>

                <v-col cols="4" align="center">
                  <div class="titulo">Resultados por Gestantes</div>

                  <Doughnut :chartData="formRelatorio.dataRelatorio.graficoGestantes" :options="doughnutOptions"></Doughnut>
                </v-col>

                <v-col cols="4" align="center">
                  <div class="titulo">Resultados por Não Gestantes</div>

                  <Doughnut :chartData="formRelatorio.dataRelatorio.graficoNaoGestantes" :options="doughnutOptions"></Doughnut>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" align="center" max-height="150px">
                  <div class="titulo">Resultados por tipo de Teste Rápido</div>

                  <Bar height="100px" :chartData="formRelatorio.dataRelatorio.graficoPorKits" :options="barOptions"></Bar>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- #endregion -->

      <!-- #region DADOS ATENDIMENTOS -->
      <v-row>
        <v-col cols="12">
          <v-card class="mx-5">
            <v-card-title v-if="formRelatorio.dataRelatorio.dataInicio">• Dispensas feitas de {{ formRelatorio.dataRelatorio.dataInicio }} até {{ formRelatorio.dataRelatorio.dataFim }}</v-card-title>
            <v-card-title v-else>• Dispensas </v-card-title>

            <v-row>
              <v-col v-if="formRelatorio.dataRelatorio.listaDispensaKit.length > 0" cols="12">
                <v-list>
                  <v-list-group v-for="(dispensaKitSelecionada, i) in formRelatorio.dataRelatorio.listaDispensaKit" :key="i" no-action sub-group>
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title>
                          <div>
                            Dispensa: N° <b>{{ dispensaKitSelecionada.dispensaKit.numeroDispensaKit }}</b>
                          </div>
                          <div v-if="dispensaKitSelecionada.paciente.descricaoCpf">
                            Dispensado para: <b>{{ dispensaKitSelecionada.paciente.descricaoNome }} | {{ formataDataBancoTipoPadrao(dispensaKitSelecionada.paciente.dataNascimento) }}</b>
                          </div>
                          <div>
                            Data: <b>{{ formataDataBancoTipoPadrao(dispensaKitSelecionada.dispensaKit.dataDispensa) }}</b>
                          </div>
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>

                    <v-list-item>
                      <v-list-item-content class="px-2">
                        <v-card class="px-4 py-6">
                          <v-card-title>Dispensa: N° {{ dispensaKitSelecionada.dispensaKit.numeroDispensaKit }}</v-card-title>
                          <v-card-subtitle>
                            Data: <b>{{ formataDataBancoTipoPadrao(dispensaKitSelecionada.dispensaKit.dataDispensa) }}</b>
                          </v-card-subtitle>

                          <v-card-text>
                            <v-row>
                              <v-col cols="6" class="py-2">
                                <div class="tituloInfo">Unidade</div>

                                <div :class="dispensaKitSelecionada.endereco.nomeEndereco ? 'descricaoInfo' : 'textoVazio'">
                                  {{ formataVazio(dispensaKitSelecionada.endereco.nomeEndereco) }}
                                </div>
                              </v-col>

                              <v-col cols="6" class="py-2">
                                <div class="tituloInfo">Responsável</div>

                                <div :class="dispensaKitSelecionada.funcionario.nomeFuncionario ? 'descricaoInfo' : 'textoVazio'">
                                  {{ formataVazio(dispensaKitSelecionada.funcionario.nomeFuncionario) }}
                                </div>
                              </v-col>

                              <v-col cols="12" class="py-2">
                                <div class="tituloInfo">Dispensado para</div>

                                <div v-if="dispensaKitSelecionada.paciente.descricaoNome" class="descricaoInfo">{{ dispensaKitSelecionada.paciente.descricaoNome }} | {{ formataDataBancoTipoPadrao(dispensaKitSelecionada.paciente.dataNascimento) }}</div>
                                <div v-else class="textoVazio">
                                  N/A
                                </div>
                              </v-col>

                              <v-col cols="6" class="py-2">
                                <div class="tituloInfo">Descrição Dispensa</div>

                                <div :class="dispensaKitSelecionada.dispensaKit.descricaoDispensa ? 'descricaoInfo' : 'textoVazio'">
                                  {{ formataVazio(dispensaKitSelecionada.dispensaKit.descricaoDispensa) }}
                                </div>
                              </v-col>

                              <v-col cols="12">
                                <v-data-table :headers="headersProdutosDispensados" :search="searchItemDispensa" :items="dispensaKitSelecionada.produtosDispensados">
                                  <template v-slot:top>
                                    <v-toolbar flat color="white">
                                      <v-toolbar-title>Produtos Dispensados</v-toolbar-title>
                                      <v-spacer></v-spacer>
                                    </v-toolbar>
                                  </template>

                                  <template v-slot:[`item.validade`]="{ item }">
                                    <v-chip :color="corValidade(item.validade)" dark>{{ item.validade }}</v-chip>
                                  </template>

                                  <template v-slot:[`item.indicadorDefeito`]="props">
                                    <v-checkbox v-model="props.item.indicadorDefeito" :false-value="0" :true-value="1" color="success" disabled></v-checkbox>
                                  </template>

                                  <template v-slot:[`item.indicadorPerdido`]="props">
                                    <v-checkbox v-model="props.item.indicadorPerdido" :false-value="0" :true-value="1" color="success" disabled></v-checkbox>
                                  </template>

                                  <template v-slot:[`item.indicadorGravidez`]="props">
                                    <v-checkbox v-model="props.item.indicadorGravidez" :false-value="0" :true-value="1" color="success" disabled></v-checkbox>
                                  </template>
                                  
                                  <template v-slot:[`item.indicadorResultado`]="props">
                                    <span v-if="props.item.indicadorTipo == 6"> HIV DUO </span>
                                      <v-radio-group v-model="props.item.indicadorResultado" row disabled>
                                        <v-radio label="Negativo" :value="0"></v-radio>
                                        <v-radio label="Positivo" :value="1"></v-radio>
                                      </v-radio-group>

                                      <span v-if="props.item.indicadorTipo == 6"> SIFILIS DUO </span>
                                      <v-radio-group v-if="props.item.indicadorTipo == 6" v-model="props.item.indicadorResultado2" row disabled>
                                        <v-radio label="Negativo" :value="0"></v-radio>
                                        <v-radio label="Positivo" :value="1"></v-radio>
                                      </v-radio-group>
                                  </template>
                                </v-data-table>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>
                </v-list>
              </v-col>

              <v-col v-else cols="12">
                <v-card-text>
                  <span class="text-subtitle-1 font-weight-light">Não é possível de exibir os dados de dispensas, pois, não há dados para exibir.</span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <!-- #endregion -->
    </FormRelatorio>
  </v-col>
</template>

<script>
import store from "@/store/index";
import axios from "../plugins/axios";
import Alertas from "@/components/Alertas.vue";
import AlertaSnackbar from "@/components/AlertaSnackbar.vue";
import Loading from "@/components/Loading.vue";
import FormRelatorio from "@/components/FormRelatorio";
import Bar from "@/components/Charts/Bar";
import Doughnut from "@/components/Charts/Doughnut";
import * as fs from "file-saver";
import { Workbook } from "exceljs";
import validation from "@/utils/validation"

export default {
  components: {
    Alertas,
    AlertaSnackbar,
    Loading,
    FormRelatorio,
    Bar,
    Doughnut,
  },

  data: () => ({
    ...validation,
    //#region Paginação
    page: 1,
    search: null,
    total: null,
    searchPaciente: null,
    searchItemDispensa: null,
    //#endregion

    //#region Alertas
    alerta: {
      texto: "",
      tipo: "",
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaSnackbar: {
      mostrar: false,
      texto: null,
      cor: "red",
    },
    //#endregion

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    headersProdutosDispensados: [
      {
        text: "Lote",
        value: "lote",
      },
      {
        text: "Produto",
        value: "nomeItem",
      },
      {
        text: "Validade",
        value: "validade",
      },
      {
        text: "Perdido",
        value: "indicadorPerdido",
      },
      {
        text: "Teste Inválido",
        value: "indicadorDefeito",
      },
      {
        text: "Gestante",
        value: "indicadorGravidez",
      },
      {
        text: "Resultado",
        value: "indicadorResultado",
      },
      {
        text: "Qt. Dispensada",
        value: "quantidadeDispensada",
      },
    ],

    filtrosRelatorio: {
      numeroEndereco: null,
      descricaoCpf: null,
      indicadorGravidez: null,
      indicadorResultado: null,
      indicadorPerdido: null,
      indicadorDefeito: null,

      dataInicio: null,
      dataInicioFormatada: null,
      dataFim: null,
      dataFimFormatada: null,
    },

    formRelatorio: {
      modalTitleToolbar: "",
      isOpen: false,
      dataRelatorio: {
        graficoDefeituosos: {
          labels: [],
          datasets: [{ data: [], backgroundColor: [] }],
        },
        graficoNaoGestantes: {
          labels: [],
          datasets: [{ data: [], backgroundColor: [] }],
        },
        graficoGestantes: {
          labels: [],
          datasets: [{ data: [], backgroundColor: [] }],
        },
        graficoPorKits: {
          labels: [],
          datasets: [{ data: [], backgroundColor: [] }],
        },
        totalDispensado: null,
        totalPositivo: null,
        totalNegativo: null,
        listaDispensaKit: [],

        dataInicio: null,
        dataFim: null,
      },
    },

    menuDe: false,
    menuAte: false,
    loading: false,
    tudoValido: false,
    botaoGerarRelatorio: false,

    //#region GRÁFICOS
    barOptions: {
      legend: {
        display: true,
        position: "top",
        align: "center",
      },
      hover: { mode: null },
    },

    doughnutOptions: {
      responsive: true,
    },
    //#endregion

    listaDeUnidades: [],
    listaDePacientes: [],
    filtroGestantes: [
      { text: "Não", value: 0 },
      { text: "Sim", value: 1 },
    ],
    filtroResultados: [
      { text: "Não Reagente", value: 0 },
      { text: "Reagente", value: 1 },
    ],
    filtroPerdidos: [
      { text: "Não", value: 0 },
      { text: "Sim", value: 1 },
    ],
    filtroDefeitos: [
      { text: "Não", value: 0 },
      { text: "Sim", value: 1 },
    ],
    dadosRelatorioOrganizados: [],
  }),

  created() {
    this.inicializar();
  },

  watch: {
    tudoValido() {
      this.botaoGerarRelatorio = !this.tudoValido;
    },
    searchPaciente() {
      if (!this.searchPaciente) {
        this.listaPacientes();
      }
    },
  },

  methods: {
    //#region LISTAGENS
    async inicializar() {
      try {
        await this.listarUnidades();
        await this.listaPacientes();
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    async listarUnidades() {
      try {
        const responseEnderecos = await axios.get("enderecoordemservico", this.config);

        this.listaDeUnidades = responseEnderecos.data.map((row) => {
          return {
            value: row.numeroEnderecoOrdemServico,
            text: row.nomeEndereco,
          };
        });
      } catch (error) {
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    async listaPacientes() {
      try {
        let responsePaciente = await axios.put("listarPacientePagination", { page: this.page, search: this.searchPaciente }, this.config);

        if (responsePaciente.data.length == 0) {
          this.loadingAutocomplete.noDataTextPaciente = "Não há pacientes cadastrados";
        }

        this.listaDePacientes = responsePaciente.data.map((pacienteSelecionado) => {
          if (pacienteSelecionado.descricaoCpf) {
            return {
              value: pacienteSelecionado.descricaoCpf,
              text: "Nome: " + pacienteSelecionado.descricaoNome + "  |  CPF: " + pacienteSelecionado.descricaoCpf,
            };
          } else if (!pacienteSelecionado.descricaoCpf && pacienteSelecionado.descricaoRG) {
            return {
              value: pacienteSelecionado.descricaoCpf,
              text: "Nome: " + pacienteSelecionado.descricaoNome + "  |  RG: " + pacienteSelecionado.descricaoRG,
            };
          } else if (!pacienteSelecionado.descricaoCpf && !pacienteSelecionado.descricaoRG && pacienteSelecionado.descricaoCpfResponsavel) {
            return {
              value: pacienteSelecionado.descricaoCpf,
              text: "Nome: " + pacienteSelecionado.descricaoNome + "  |  CPF do Responsável: " + pacienteSelecionado.descricaoCpfResponsavel,
            };
          } else {
            return {
              value: pacienteSelecionado.descricaoCpf,
              text: "Nome: " + pacienteSelecionado.descricaoNome + "  |  Não há dados informados!",
            };
          }
        });
      } catch (error) {
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },
    //#endregion

    //#region EVENTOS REQUISIÇÃO
    async gerarRelatorio() {
      this.loading = true;
      try {
        this.alerta.tipo = "";

        const dadosRelatorio = await axios.put("relatoriodispensakit", this.filtrosRelatorio, this.config);

        this.dadosRelatorioOrganizados = await this.organizarDadosRelatorio(dadosRelatorio.data.listaDispensaKit);
        console.log(dadosRelatorio.data)
        console.log(this.dadosRelatorioOrganizados)
        this.modalRelatorio(dadosRelatorio.data);
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
        this.loading = false;
      }
    },
    //#endregion

    async  organizarDadosRelatorio(arrayDeObjetos) {
  const organizadoPorNomeItem = [];

  arrayDeObjetos.forEach((objeto) => {
    objeto.produtosDispensados.forEach((produto) => {
      const nomeItem = produto.nomeItem;
      const indicadorGravidez = produto.indicadorGravidez;
      const indicadorResultado = produto.indicadorResultado;
      const indicadorResultado2 = produto.indicadorResultado2;
      const indicadorPerdido = produto.indicadorPerdido;
      const indicadorDefeito = produto.indicadorDefeito;

      const adicionarItem = (nome, resultado, gravidez, perdido, defeito) => {
        const itemExistente = organizadoPorNomeItem.find((item) => item.nomeItem === nome);

        if (!itemExistente) {
          const novoItem = {
            nomeItem: nome,
            gravidez0: { resultado0: 0, resultado1: 0 },
            gravidez1: { resultado0: 0, resultado1: 0 },
            perdido0: 0,
            perdido1: 0,
            defeito0: 0,
            defeito1: 0,
          };
          organizadoPorNomeItem.push(novoItem);
        }

        const itemAtual = organizadoPorNomeItem.find((item) => item.nomeItem === nome);

        if (perdido === 0 && defeito === 0) {
          if (gravidez === 0) {
            if (resultado === 0) {
              itemAtual.gravidez0.resultado0++;
            } else if (resultado === 1) {
              itemAtual.gravidez0.resultado1++;
            }
          } else if (gravidez === 1) {
            if (resultado === 0) {
              itemAtual.gravidez1.resultado0++;
            } else if (resultado === 1) {
              itemAtual.gravidez1.resultado1++;
            }
          }
        }

        if (perdido === 0) {
          itemAtual.perdido0++;
        } else if (perdido === 1) {
          itemAtual.perdido1++;
        }

        if (defeito === 0) {
          itemAtual.defeito0++;
        } else if (defeito === 1) {
          itemAtual.defeito1++;
        }
      };

      if (nomeItem === "TESTE RAPIDO DUO ABBOT - HIV/SIFILIS" && indicadorResultado2 !== undefined) {
        // Separar em dois itens: HIV e SIFILIS
        adicionarItem(nomeItem + " - HIV", indicadorResultado, indicadorGravidez, indicadorPerdido, indicadorDefeito);
        adicionarItem(nomeItem + " - SIFILIS", indicadorResultado2, indicadorGravidez, indicadorPerdido, indicadorDefeito);
      } else {
        // Contagem normal para outros itens
        adicionarItem(nomeItem, indicadorResultado, indicadorGravidez, indicadorPerdido, indicadorDefeito);
      }
    });
  });

  return organizadoPorNomeItem;
},


    //#region FUNÇÕES MODAL
    async modalRelatorio(dados) {
      try {
        this.formRelatorio.dataRelatorio.graficoDefeituosos = dados.graficoDefeituosos;
        this.formRelatorio.dataRelatorio.graficoNaoGestantes = dados.graficoNaoGestantes;
        this.formRelatorio.dataRelatorio.graficoGestantes = dados.graficoGestantes;
        this.formRelatorio.dataRelatorio.graficoPorKits = dados.graficoPorKits;

        this.formRelatorio.dataRelatorio.totalDispensado = dados.totalDispensado;
        this.formRelatorio.dataRelatorio.totalPositivo = dados.totalPositivo;
        this.formRelatorio.dataRelatorio.totalNegativo = dados.totalNegativo;
        this.formRelatorio.dataRelatorio.listaDispensaKit = dados.listaDispensaKit;

        this.formRelatorio.dataRelatorio.dataInicio = this.filtrosRelatorio.dataInicioFormatada ? this.filtrosRelatorio.dataInicioFormatada : null;
        this.formRelatorio.dataRelatorio.dataFim = this.filtrosRelatorio.dataFimFormatada ? this.filtrosRelatorio.dataFimFormatada : this.filtrosRelatorio.dataInicioFormatada ? this.formatarData(new Date().toISOString().substr(0, 10)) : null;
      } catch (error) {
        console.log(error);
      } finally {
        this.formRelatorio.modalTitleToolbar = "Relatório de Dispensas Teste Rápido";
        this.formRelatorio.isOpen = true;
        this.loading = false;
      }
    },
    //#endregion

    //#region HANDLERS
    async buscarPacientes() {
      await this.listaPacientes();
    },

    fecharFormRelatorio() {
      this.filtrosRelatorio.numeroEndereco = null;
      this.filtrosRelatorio.descricaoCpf = null;
      this.filtrosRelatorio.indicadorGravidez = null;
      this.filtrosRelatorio.indicadorResultado = null;
      this.filtrosRelatorio.indicadorPerdido = null;
      this.filtrosRelatorio.indicadorDefeito = null;
      this.filtrosRelatorio.dataInicio = null;
      this.filtrosRelatorio.dataInicioFormatada = null;
      this.filtrosRelatorio.dataFim = null;
      this.filtrosRelatorio.dataFimFormatada = null;

      this.formRelatorio.dataRelatorio.graficoDefeituosos = {
        labels: [],
        datasets: [{ data: [], backgroundColor: [] }],
      };
      this.formRelatorio.dataRelatorio.graficoNaoGestantes = {
        labels: [],
        datasets: [{ data: [], backgroundColor: [] }],
      };
      this.formRelatorio.dataRelatorio.graficoGestantes = {
        labels: [],
        datasets: [{ data: [], backgroundColor: [] }],
      };
      this.formRelatorio.dataRelatorio.graficoPorKits = {
        labels: [],
        datasets: [{ data: [], backgroundColor: [] }],
      };
      this.formRelatorio.dataRelatorio.totalDispensado = null;
      this.formRelatorio.dataRelatorio.totalPositivo = null;
      this.formRelatorio.dataRelatorio.totalNegativo = null;
      this.formRelatorio.dataRelatorio.listaDispensaKit = [];
      this.formRelatorio.dataRelatorio.dataInicio = null;
      this.formRelatorio.dataRelatorio.dataFim = null;

      this.formRelatorio.isOpen = false;
    },
    //#endregion

    //#region EXCEL
    async gerarExcel(dados) {
      this.loading = true;

      const workbook = new Workbook();

      let max = 0;
      let numLines = 0;

      //#region STYLES
      var borderStyles = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };

      const fontStyleTituloInfo = { name: "Arial", family: 2, size: 13, bold: true, color: { argb: "232323" } };
      const fontStyleHeaderText = { name: "Arial", family: 2, size: 10, bold: true, color: { argb: "232323" } };
      const fontStyleDescricaoInfo = { name: "Arial", family: 2, size: 12, color: { argb: "232323" } };
      const fontStyleSemInfo = { name: "Arial", family: 2, size: 12, color: { argb: "9E9E9E" } };
      const alignmentNormalStyle = { vertical: "middle", horizontal: "left", wrapText: true };
      const alignmentCenterStyle = { vertical: "middle", horizontal: "center", wrapText: true };
      const mainFillColorStyle = { type: "pattern", pattern: "solid", fgColor: { argb: "66cc99" } };
      const fillColorStyle = { type: "pattern", pattern: "solid", fgColor: { argb: "ecf0f1" } };
      //#endregion

      let posicaoLinha = 1;
      var worksheet = workbook.addWorksheet("Atendimentos", {
        views: [{ showGridLines: false }],
      });

      worksheet.columns = [
        { key: "col1", width: 16 },
        { key: "col2", width: 16 },
        { key: "col3", width: 16 },
        { key: "col4", width: 16 },
        { key: "col5", width: 16 },
        { key: "col6", width: 16 },
        { key: "col7", width: 16 },
        { key: "col8", width: 16 },
      ];

      worksheet.mergeCells("A" + posicaoLinha + ":H" + posicaoLinha);
      worksheet.getCell("A" + posicaoLinha).value = dados.dataInicio ? "Dispensas feitas de " + dados.dataInicio + " até " + dados.dataFim + " | Total Dispensado: " + dados.totalDispensado : "Dispensas | Total Dispensado: " + dados.totalDispensado;
      worksheet.getCell("A" + posicaoLinha).font = fontStyleTituloInfo;
      worksheet.getCell("A" + posicaoLinha).alignment = alignmentCenterStyle;
      worksheet.getCell("A" + posicaoLinha).fill = mainFillColorStyle;
      worksheet.getRow(posicaoLinha).height = 30;
      posicaoLinha++;

      if (dados.listaDispensaKit.length > 0) {
        dados.listaDispensaKit.map((dispensaKitSelecionada) => {
          worksheet.mergeCells("A" + posicaoLinha + ":H" + posicaoLinha);
          worksheet.getCell("A" + posicaoLinha).value = "N° " + dispensaKitSelecionada.dispensaKit.numeroDispensaKit + " | Data: " + this.formataDataBancoTipoPadrao(dispensaKitSelecionada.dispensaKit.dataDispensa);
          worksheet.getCell("A" + posicaoLinha).font = fontStyleTituloInfo;
          worksheet.getCell("A" + posicaoLinha).alignment = alignmentCenterStyle;
          worksheet.getCell("A" + posicaoLinha).fill = fillColorStyle;
          worksheet.getRow(posicaoLinha).height = 25;
          posicaoLinha++;

          worksheet.mergeCells("A" + posicaoLinha + ":D" + posicaoLinha);
          worksheet.getCell("A" + posicaoLinha).value = "Unidade";
          worksheet.getCell("A" + posicaoLinha).font = fontStyleTituloInfo;
          worksheet.getCell("A" + posicaoLinha).alignment = alignmentNormalStyle;
          worksheet.getCell("A" + posicaoLinha).fill = fillColorStyle;

          worksheet.mergeCells("E" + posicaoLinha + ":H" + posicaoLinha);
          worksheet.getCell("E" + posicaoLinha).value = "Responsável";
          worksheet.getCell("E" + posicaoLinha).font = fontStyleTituloInfo;
          worksheet.getCell("E" + posicaoLinha).alignment = alignmentNormalStyle;
          worksheet.getCell("E" + posicaoLinha).fill = fillColorStyle;
          posicaoLinha++;

          worksheet.mergeCells("A" + posicaoLinha + ":D" + posicaoLinha);
          worksheet.getCell("A" + posicaoLinha).value = this.formataVazio(dispensaKitSelecionada.endereco.nomeEndereco);
          worksheet.getCell("A" + posicaoLinha).font = dispensaKitSelecionada.endereco.nomeEndereco ? fontStyleDescricaoInfo : fontStyleSemInfo;
          worksheet.getCell("A" + posicaoLinha).alignment = alignmentNormalStyle;

          worksheet.mergeCells("E" + posicaoLinha + ":H" + posicaoLinha);
          worksheet.getCell("E" + posicaoLinha).value = this.formataVazio(dispensaKitSelecionada.funcionario.nomeFuncionario);
          worksheet.getCell("E" + posicaoLinha).font = dispensaKitSelecionada.funcionario.nomeFuncionario ? fontStyleDescricaoInfo : fontStyleSemInfo;
          worksheet.getCell("E" + posicaoLinha).alignment = alignmentNormalStyle;

          max = Math.max(dispensaKitSelecionada.endereco.nomeEndereco != null ? this.formataVazio(dispensaKitSelecionada.endereco.nomeEndereco).length : 0, dispensaKitSelecionada.funcionario.nomeFuncionario != null ? this.formataVazio(dispensaKitSelecionada.funcionario.nomeFuncionario).length : 0);
          numLines = Math.ceil(max / 60);
          worksheet.getRow(posicaoLinha).height = numLines * 16;
          posicaoLinha++;

          worksheet.mergeCells("A" + posicaoLinha + ":D" + posicaoLinha);
          worksheet.getCell("A" + posicaoLinha).value = "Nome (Iniciais)";
          worksheet.getCell("A" + posicaoLinha).font = fontStyleTituloInfo;
          worksheet.getCell("A" + posicaoLinha).alignment = alignmentNormalStyle;
          worksheet.getCell("A" + posicaoLinha).fill = fillColorStyle;

          worksheet.mergeCells("E" + posicaoLinha + ":H" + posicaoLinha);
          worksheet.getCell("E" + posicaoLinha).value = "Data Nascimento";
          worksheet.getCell("E" + posicaoLinha).font = fontStyleTituloInfo;
          worksheet.getCell("E" + posicaoLinha).alignment = alignmentNormalStyle;
          worksheet.getCell("E" + posicaoLinha).fill = fillColorStyle;
          posicaoLinha++;

          worksheet.mergeCells("A" + posicaoLinha + ":D" + posicaoLinha);
          worksheet.getCell("A" + posicaoLinha).value = dispensaKitSelecionada.paciente.descricaoNome ? dispensaKitSelecionada.paciente.descricaoNome : "N/A";
          worksheet.getCell("A" + posicaoLinha).font = dispensaKitSelecionada.paciente.descricaoNome ? fontStyleDescricaoInfo : fontStyleSemInfo;
          worksheet.getCell("A" + posicaoLinha).alignment = alignmentNormalStyle;

          worksheet.mergeCells("E" + posicaoLinha + ":H" + posicaoLinha);
          worksheet.getCell("E" + posicaoLinha).value = dispensaKitSelecionada.paciente.dataNascimento ? this.formataDataBancoTipoPadrao(dispensaKitSelecionada.paciente.dataNascimento) : "N/A";
          worksheet.getCell("E" + posicaoLinha).font = dispensaKitSelecionada.paciente.dataNascimento ? fontStyleDescricaoInfo : fontStyleSemInfo;
          worksheet.getCell("E" + posicaoLinha).alignment = alignmentNormalStyle;

          max = Math.max(dispensaKitSelecionada.paciente.descricaoNome != null ? dispensaKitSelecionada.paciente.descricaoNome.length : 0, dispensaKitSelecionada.paciente.dataNascimento ? this.formataDataBancoTipoPadrao(dispensaKitSelecionada.paciente.dataNascimento).length : 0);
          numLines = Math.ceil(max / 60);
          worksheet.getRow(posicaoLinha).height = numLines * 16;
          posicaoLinha++;

          worksheet.mergeCells("A" + posicaoLinha + ":H" + posicaoLinha);
          worksheet.getCell("A" + posicaoLinha).value = "Descrição Dispensa";
          worksheet.getCell("A" + posicaoLinha).font = fontStyleTituloInfo;
          worksheet.getCell("A" + posicaoLinha).alignment = alignmentNormalStyle;
          worksheet.getCell("A" + posicaoLinha).fill = fillColorStyle;
          posicaoLinha++;

          worksheet.mergeCells("A" + posicaoLinha + ":H" + posicaoLinha);
          worksheet.getCell("A" + posicaoLinha).value = this.formataVazio(dispensaKitSelecionada.dispensaKit.descricaoDispensa);
          worksheet.getCell("A" + posicaoLinha).font = dispensaKitSelecionada.dispensaKit.descricaoDispensa ? fontStyleDescricaoInfo : fontStyleSemInfo;
          worksheet.getCell("A" + posicaoLinha).alignment = alignmentNormalStyle;

          max = dispensaKitSelecionada.dispensaKit.descricaoDispensa ? dispensaKitSelecionada.dispensaKit.descricaoDispensa.length : 0;
          numLines = Math.ceil(max / 100);
          worksheet.getRow(posicaoLinha).height = numLines * 16;
          posicaoLinha++;

          worksheet.getRow(posicaoLinha).height = 24;
          worksheet.getCell("A" + posicaoLinha).value = "Lote";
          worksheet.getCell("A" + posicaoLinha).font = fontStyleHeaderText;
          worksheet.getCell("A" + posicaoLinha).alignment = alignmentCenterStyle;
          worksheet.getCell("A" + posicaoLinha).fill = fillColorStyle;

          worksheet.getCell("B" + posicaoLinha).value = "Teste Rápido";
          worksheet.getCell("B" + posicaoLinha).font = fontStyleHeaderText;
          worksheet.getCell("B" + posicaoLinha).alignment = alignmentCenterStyle;
          worksheet.getCell("B" + posicaoLinha).fill = fillColorStyle;

          worksheet.getCell("C" + posicaoLinha).value = "Validade";
          worksheet.getCell("C" + posicaoLinha).font = fontStyleHeaderText;
          worksheet.getCell("C" + posicaoLinha).alignment = alignmentCenterStyle;
          worksheet.getCell("C" + posicaoLinha).fill = fillColorStyle;

          worksheet.getCell("D" + posicaoLinha).value = "Perdido";
          worksheet.getCell("D" + posicaoLinha).font = fontStyleHeaderText;
          worksheet.getCell("D" + posicaoLinha).alignment = alignmentCenterStyle;
          worksheet.getCell("D" + posicaoLinha).fill = fillColorStyle;

          worksheet.getCell("E" + posicaoLinha).value = "Defeito";
          worksheet.getCell("E" + posicaoLinha).font = fontStyleHeaderText;
          worksheet.getCell("E" + posicaoLinha).alignment = alignmentCenterStyle;
          worksheet.getCell("E" + posicaoLinha).fill = fillColorStyle;

          worksheet.getCell("F" + posicaoLinha).value = "Gestante";
          worksheet.getCell("F" + posicaoLinha).font = fontStyleHeaderText;
          worksheet.getCell("F" + posicaoLinha).alignment = alignmentCenterStyle;
          worksheet.getCell("F" + posicaoLinha).fill = fillColorStyle;

          worksheet.getCell("G" + posicaoLinha).value = "Resultado";
          worksheet.getCell("G" + posicaoLinha).font = fontStyleHeaderText;
          worksheet.getCell("G" + posicaoLinha).alignment = alignmentCenterStyle;
          worksheet.getCell("G" + posicaoLinha).fill = fillColorStyle;

          worksheet.getCell("H" + posicaoLinha).value = "Quantidade";
          worksheet.getCell("H" + posicaoLinha).font = fontStyleHeaderText;
          worksheet.getCell("H" + posicaoLinha).alignment = alignmentCenterStyle;
          worksheet.getCell("H" + posicaoLinha).fill = fillColorStyle;
          posicaoLinha++;

          let totalDispensado = 0;
          dispensaKitSelecionada.produtosDispensados.map((produtoSelecionado) => {
            worksheet.getCell("A" + posicaoLinha).value = produtoSelecionado.lote;
            worksheet.getCell("A" + posicaoLinha).font = fontStyleDescricaoInfo;
            worksheet.getCell("A" + posicaoLinha).alignment = alignmentCenterStyle;

            worksheet.getCell("B" + posicaoLinha).value = produtoSelecionado.nomeItem;
            worksheet.getCell("B" + posicaoLinha).font = fontStyleDescricaoInfo;
            worksheet.getCell("B" + posicaoLinha).alignment = alignmentCenterStyle;

            worksheet.getCell("C" + posicaoLinha).value = produtoSelecionado.validade;
            worksheet.getCell("C" + posicaoLinha).font = fontStyleDescricaoInfo;
            worksheet.getCell("C" + posicaoLinha).alignment = alignmentCenterStyle;

            worksheet.getCell("D" + posicaoLinha).value = this.formataPerdido(produtoSelecionado.indicadorPerdido);
            worksheet.getCell("D" + posicaoLinha).font = fontStyleDescricaoInfo;
            worksheet.getCell("D" + posicaoLinha).alignment = alignmentCenterStyle;

            worksheet.getCell("E" + posicaoLinha).value = this.formataDefeito(produtoSelecionado.indicadorDefeito);
            worksheet.getCell("E" + posicaoLinha).font = fontStyleDescricaoInfo;
            worksheet.getCell("E" + posicaoLinha).alignment = alignmentCenterStyle;

            worksheet.getCell("F" + posicaoLinha).value = this.formataGestante(produtoSelecionado.indicadorGravidez);
            worksheet.getCell("F" + posicaoLinha).font = fontStyleDescricaoInfo;
            worksheet.getCell("F" + posicaoLinha).alignment = alignmentCenterStyle;

            if(produtoSelecionado.indicadorTipo==6){
              worksheet.getCell("G" + posicaoLinha).value = 'HIV DUO : '+this.formataResultado(produtoSelecionado.indicadorResultado)+"\n SIFILIS DUO: "+this.formataResultado(produtoSelecionado.indicadorResultado);
              worksheet.getCell("G" + posicaoLinha).font = fontStyleDescricaoInfo;
              worksheet.getCell("G" + posicaoLinha).alignment = alignmentCenterStyle;
            }else{
              worksheet.getCell("G" + posicaoLinha).value = this.formataResultado(produtoSelecionado.indicadorResultado);
              worksheet.getCell("G" + posicaoLinha).font = fontStyleDescricaoInfo;
              worksheet.getCell("G" + posicaoLinha).alignment = alignmentCenterStyle;
            }
          

            worksheet.getCell("H" + posicaoLinha).value = produtoSelecionado.quantidadeDispensada;
            worksheet.getCell("H" + posicaoLinha).font = fontStyleDescricaoInfo;
            worksheet.getCell("H" + posicaoLinha).alignment = alignmentCenterStyle;

            const nomeItemLength = produtoSelecionado.nomeItem ? produtoSelecionado.nomeItem.length : 0;

            const numLines = Math.ceil(nomeItemLength / 14);
            worksheet.getRow(posicaoLinha).height = numLines * 20;
            posicaoLinha++;

            totalDispensado = totalDispensado + parseInt(produtoSelecionado.quantidadeDispensada);
          });

          worksheet.mergeCells("A" + posicaoLinha + ":G" + posicaoLinha);
          worksheet.getCell("A" + posicaoLinha).value = "Total: ";
          worksheet.getCell("A" + posicaoLinha).font = fontStyleHeaderText;
          worksheet.getCell("A" + posicaoLinha).alignment = { vertical: "middle", horizontal: "right", wrapText: true };
          worksheet.getCell("A" + posicaoLinha).fill = fillColorStyle;

          worksheet.getCell("H" + posicaoLinha).value = totalDispensado;
          worksheet.getCell("H" + posicaoLinha).font = fontStyleDescricaoInfo;
          worksheet.getCell("H" + posicaoLinha).alignment = alignmentCenterStyle;
          posicaoLinha++;
          posicaoLinha++;
          posicaoLinha++;
        });
      } else {
        worksheet.mergeCells("A" + posicaoLinha + ":H" + posicaoLinha);
        worksheet.getCell("A" + posicaoLinha).value = "Não é possível de exibir os dados de dispensas, pois, não há dados para exibir.";
        worksheet.getCell("A" + posicaoLinha).font = fontStyleDescricaoInfo;
        worksheet.getCell("A" + posicaoLinha).alignment = alignmentCenterStyle;
      }

      worksheet.eachRow({ includeEmpty: true }, function(row) {
        row.eachCell({ includeEmpty: true }, function(cell) {
          cell.border = borderStyles;
        });
      });

      const nomeArquivo = dados.dataInicio ? "Dispensas Teste Rápido - De " + dados.dataInicio + " até " + dados.dataFim : "Dispensas Teste Rápido";

      workbook.xlsx.writeBuffer().then(function(data) {
        var blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fs.saveAs(blob, nomeArquivo + ".xlsx");
      });

      this.loading = false;
    },
    //#endregion

    //#region FORMATADORES
    formataVazio(texto) {
      switch (texto) {
        case null:
          return "Não informado";
        case "":
          return "Não informado";
        case texto:
          return texto;
      }
    },

    formataGestante(texto) {
      switch (texto) {
        case null:
          return "Não informado";
        case "":
          return "Não informado";
        case 0:
          return "Não";
        case 1:
          return "Sim";
      }
    },

    formataResultado(texto) {
      switch (texto) {
        case null:
          return "Não informado";
        case "":
          return "Não informado";
        case 0:
          return "Não Reagente";
        case 1:
          return "Reagente";
      }
    },

    formataDefeito(texto) {
      switch (texto) {
        case null:
          return "Não informado";
        case "":
          return "Não informado";
        case 0:
          return "Não";
        case 1:
          return "Sim";
      }
    },

    formataPerdido(texto) {
      switch (texto) {
        case null:
          return "Não informado";
        case "":
          return "Não informado";
        case 0:
          return "Não";
        case 1:
          return "Sim";
      }
    },

    formataDataBanco(data) {
      if (data) {
        if (data.includes("T")) {
          const dataSeparada = data.split("T")[0];
          const ano = dataSeparada.split("-")[0];
          const mes = dataSeparada.split("-")[1];
          const dia = dataSeparada.split("-")[2];
          const dia2 = dia.substring(0, 2);

          return ano + "-" + ("0" + mes).slice(-2) + "-" + ("0" + dia2).slice(-2);
        } else if (data.includes(" ")) {
          const dataSeparada = data.split(" ")[0];
          const ano = dataSeparada.split("-")[0];
          const mes = dataSeparada.split("-")[1];
          const dia = dataSeparada.split("-")[2];
          const dia2 = dia.substring(0, 2);

          return ano + "-" + ("0" + mes).slice(-2) + "-" + ("0" + dia2).slice(-2);
        } else {
          const ano = data.split("-")[0];
          const mes = data.split("-")[1];
          const dia = data.split("-")[2];
          const dia2 = dia.substring(0, 2);

          return ano + "-" + ("0" + mes).slice(-2) + "-" + ("0" + dia2).slice(-2);
        }
      } else {
        return null;
      }
    },

    formataDataBancoTipoPadrao(data) {
      if (data) {
        if (data.includes("T")) {
          const dataSeparada = data.split("T")[0];
          const ano = dataSeparada.split("-")[0];
          const mes = dataSeparada.split("-")[1];
          const dia = dataSeparada.split("-")[2];
          const dia2 = dia.substring(0, 2);

          return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
        } else if (data.includes(" ")) {
          const dataSeparada = data.split(" ")[0];
          const ano = dataSeparada.split("-")[0];
          const mes = dataSeparada.split("-")[1];
          const dia = dataSeparada.split("-")[2];
          const dia2 = dia.substring(0, 2);

          return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
        } else {
          const ano = data.split("-")[0];
          const mes = data.split("-")[1];
          const dia = data.split("-")[2];
          const dia2 = dia.substring(0, 2);

          return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
        }
      } else {
        return null;
      }
    },

    formatarData(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    analizarData(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    corValidade(data) {
      if (data) {
        var ano = data.split("/")[2];
        var mes = data.split("/")[1];
        var dia = data.split("/")[0];
        // var dia2  = dia.substring(0,2)

        const dataFormatada = ano + "-" + ("0" + mes).slice(-2) + "-" + dia;

        const dias = this.verificarDias(dataFormatada);

        if (store.state.numeroEndereco == 127 || store.state.numeroEndereco == "127" || store.state.numeroEndereco == 124 || store.state.numeroEndereco == "124") {
          if (dias > 90) {
            return "green";
          } else if (dias > 0 && dias <= 90) {
            return "orange";
          } else if (dias <= 0) {
            return "red";
          }
        } else {
          if (dias > 30) {
            return "green";
          } else if (dias > 0 && dias <= 30) {
            return "orange";
          } else if (dias <= 0) {
            return "red";
          }
        }
      }
    },

    verificarDias(data) {
      const dateAtual = new Date().toISOString().substr(0, 10);
      const daterecive = data;

      const diferenceOfDates = new Date(daterecive) - new Date(dateAtual);
      const daysOfDiference = Math.ceil(diferenceOfDates / (1000 * 60 * 60 * 24));

      return daysOfDiference;
    },

    formatarNome(nomeCompleto) {
      const palavras = nomeCompleto.split(" ");
      let iniciais = "";
      for (const palavra of palavras) {
        const inicial = palavra.charAt(0).toUpperCase();
        iniciais += inicial;
      }

      return iniciais;
    },

    filter: function(evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[0-9]*?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    //#endregion
  },
};
</script>

<style>
.tituloInfo {
  font-size: smaller;
  font-weight: 500;
  color: rgba(85, 85, 85, 0.7);
}
.descricaoInfo {
  font-size: larger;
  font-weight: 400;
  color: rgb(35, 35, 35);
}
.titulo {
  font-size: large;
  font-weight: 500;
  color: #212121;
}
.textoVazio {
  color: rgba(0, 0, 0, 0.3);
}
</style>
